<ng-container *transloco="let t">
  <mat-toolbar class="tool-bar">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
      <span style="font-size: 20px;">
        {{ id ? t("user.Update") : t("user.Create") }}
      </span>
      <span class="example-spacer"></span>
      <mat-icon mat-dialog-close>close</mat-icon>
    </mat-toolbar-row>
  </mat-toolbar>
  <form [formGroup]="userForm" (ngSubmit)="checkValidation()">
    <mat-dialog-content>
      <div fxLayout="row wrap" fxLayoutGap="10px" class="padding-top-bottom-10">
        <div fxFlex="100" fxl style="display:none;">
          <mat-form-field class="example-full-width">
            <input matInput placeholder="Id" formControlName="id" />
          </mat-form-field>
        </div>
        <div fxFlex="48">
          <mat-form-field class="example-full-width" appearance="outline" style="margin-bottom: 7px;">
            <mat-label>{{ t('user.Name') }}</mat-label>
            <input matInput formControlName="firstName" [readonly]="id" />
            <mat-error *ngIf="userForm.get('firstName')?.hasError('required')">
              {{ t("user.NameRequired") }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="48">
          <mat-form-field class="example-full-width" appearance="outline" style="margin-bottom: 7px;">
            <mat-label>{{ t('user.ArabicName') }}</mat-label>
            <input matInput formControlName="arabicName" [readonly]="id" required />
            <mat-error *ngIf="userForm.get('arabicName')?.errors?.['required']">
              {{ t("user.ArabicNameRequired") }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="48">
          <mat-form-field class="example-full-width" appearance="outline" style="margin-bottom: 7px;">
            <mat-label>{{ t("user.Email") }}</mat-label>
            <input matInput formControlName="email" [readonly]="id" required />
            <mat-error *ngIf="userForm.get('email')?.errors?.['required']">
              {{ t("user.Emailrequired") }}
            </mat-error>

            <mat-error *ngIf="userForm.get('email')?.errors?.['usernameExists']">
              {{ t("user.UserNameexists") }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="48">
          <mat-form-field class="example-full-width" appearance="outline" style="margin-bottom: 7px;">
            <mat-label>{{ t("user.DepartmentName") }}</mat-label>
            <mat-select formControlName="departmentName" required>
              <mat-option [value]="null">-- Select --</mat-option>
              <mat-option *ngFor="let department of departmentList" [value]="department">
                {{ department }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="userForm.get('departmentName')?.hasError('required')">
              {{ t("user.DepartmentNameRequired") }}
            </mat-error>
          </mat-form-field>

        </div>
        <div fxFlex="48">
          <mat-form-field appearance="outline" class="example-full-width" style="margin-bottom: 7px;">
            <mat-label>{{ t('user.Designation') }}</mat-label>
            <input matInput formControlName="designation" [readonly]="id" required />
            <mat-error *ngIf="userForm.get('designation')?.errors?.['required']">
              {{ t("user.DesignationRequired") }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="48">
          <div class="custom-phone-wrapper"
            [class.invalid]="validate('phoneNumber')?.invalid && validate('phoneNumber')?.touched">
            <label class="custom-label">
              {{ t('user.MobileNo') }} <span class="required">*</span>
            </label>

            <ngx-intl-tel-input [cssClass]="'mobile-code-input'" [enablePlaceholder]="true" [searchCountryFlag]="true"
              [selectedCountryISO]="selectedCountry" [onlyCountries]="onlyCountries" [maxLength]="15"
              [phoneValidation]="true" [id]="'phone'" [separateDialCode]="true" name="phone"
              formControlName="phoneNumber">
            </ngx-intl-tel-input>

            <div class="mat-error-text"
              *ngIf="validate('phoneNumber')?.hasError('validatePhoneNumber') && validate('phoneNumber')?.touched">
              {{ t("challenge.InvalidPhoneNumber") }}
            </div>
          </div>
        </div>
        <div fxFlex="100">
          <div fxFlex="50">
            <mat-label>{{ t("user.Gender") }}</mat-label>
            <mat-radio-group aria-label="Gender" formControlName="gender" style="margin-bottom: 7px;">
              <mat-radio-button style="padding-right: 5px;" value="M">{{ t("user.Male") }}</mat-radio-button>
              <mat-radio-button value="F">{{
                t("user.Female")
                }}</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="userForm.get('gender')?.hasError('required') && (userForm.get('gender')?.dirty || userForm.get('gender')?.touched)">
              {{ t("user.GenderRequired") }}
            </mat-error>
          </div>
          <div fxFlex="50">
            <mat-label>{{ t("user.Status") }}</mat-label>
            <mat-radio-group aria-label="Active/Inactive" formControlName="active" style="margin-bottom: 7px;">
              <mat-radio-button style="padding-right: 5px;" [value]="true">{{
                t("user.Active")
                }}</mat-radio-button>
              <mat-radio-button [value]="false">{{
                t("user.InActive")
                }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div fxFlex="100">
          <mat-label><b>{{ t("User Regions") | uppercase }}</b></mat-label>

          <div fxLayout="column" fxLayoutGap="8px">
            <mat-radio-group [value]="primaryRegionId" (change)="onPrimaryChange($event.value)">

              <div *ngFor="let region of userRegions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">

                <!-- Region checkbox -->
                <mat-checkbox [checked]="region.selected" (change)="onRegionChange(region, $event)">
                  {{ region.region }}
                </mat-checkbox>

                <!-- Primary region radio -->
                <mat-radio-button [value]="region.id" [disabled]="!region.selected">
                  {{ t('Is Default region?') }}
                </mat-radio-button>

                <!-- Organisations inline -->
                <ng-container *ngIf="region.selected && userOrganisationsMap[region.id]?.length">
                  <span style="margin-left: 16px;"><b>{{ t('Organizations') }}:</b></span>

                  <mat-checkbox *ngFor="let org of userOrganisationsMap[region.id]" [checked]="org.selected"
                    (change)="onOrgChange(org, $event, region.id)" style="margin-left: 8px;">
                    {{ org.organisationName }}
                  </mat-checkbox>
                </ng-container>

              </div>

            </mat-radio-group>
          </div>
        </div>
        <div fxFlex="100">
          <div style="margin-top: 10px;">
            <mat-label><b>{{ t("user.assignTiles") | uppercase }}</b></mat-label>
            <mat-table [dataSource]="dataSource" matSort class="propcentra-grid">

              <!-- Module Column -->
              <ng-container matColumnDef="title">
                <mat-header-cell fxFlex="50" *matHeaderCellDef class="title-col"> {{ t("user.title") }}
                </mat-header-cell>
                <mat-cell fxFlex="50" *matCellDef="let tile" class="title-col"> {{ tile.title }} </mat-cell>
              </ng-container>

              <!-- Admin Column -->
              <ng-container matColumnDef="admin">
                <mat-header-cell *matHeaderCellDef> {{ t("user.admin") }} </mat-header-cell>
                <mat-cell *matCellDef="let tile; let i = index" class="text-center">
                  <mat-checkbox [formControl]="getPermissionControlDynamic(i, 'admin')"
                    (change)="onAdminChangeDynamic(i, $event.checked)">
                  </mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Edit, View, Delete Columns -->
              <!-- <ng-container *ngFor="let perm of ['edit','view','delete','reviewer']" [matColumnDef]="perm">
                <mat-header-cell *matHeaderCellDef> {{ t('user.' + perm) }} </mat-header-cell>
                <mat-cell *matCellDef="let tile; let i = index" class="text-center">
                  <mat-checkbox [formControl]="getPermissionControlDynamic(i, perm)"></mat-checkbox>
                </mat-cell>
              </ng-container> -->

              <!-- Edit Column -->
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef> {{ t('user.edit') }} </mat-header-cell>
                <mat-cell *matCellDef="let tile; let i = index" class="text-center">
                  <mat-checkbox [formControl]="getPermissionControlDynamic(i, 'edit')"
                    (change)="onEditChangeDynamic(i, $event.checked)"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- View Column -->
              <ng-container matColumnDef="view">
                <mat-header-cell *matHeaderCellDef> {{ t('user.view') }} </mat-header-cell>
                <mat-cell *matCellDef="let tile; let i = index" class="text-center">
                  <mat-checkbox [formControl]="getPermissionControlDynamic(i, 'view')"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Delete Column -->
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> {{ t('user.delete') }} </mat-header-cell>
                <mat-cell *matCellDef="let tile; let i = index" class="text-center">
                  <mat-checkbox [formControl]="getPermissionControlDynamic(i, 'delete')"
                    (change)="onDeleteChangeDynamic(i, $event.checked)"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Reviewer Column -->
              <ng-container matColumnDef="reviewer">
                <mat-header-cell *matHeaderCellDef> {{ t('user.reviewer') }} </mat-header-cell>
                <mat-cell *matCellDef="let tile; let i = index" class="text-center">
                  <mat-checkbox [formControl]="getPermissionControlDynamic(i, 'reviewer')"
                    (change)="onReviewerChangeDynamic(i, $event.checked)"></mat-checkbox>
                </mat-cell>
              </ng-container>


              <!-- Rows -->
              <mat-header-row *matHeaderRowDef="['title','admin','edit','view','delete','reviewer']"></mat-header-row>
              <mat-row *matRowDef="let row; columns: ['title','admin','edit','view','delete','reviewer']"></mat-row>
            </mat-table>

          </div>
        </div>
      </div>
    </mat-dialog-content>
  </form>

  <div fxLayout="row" class="dialog-actions">
    <button mat-flat-button color="primary" type="submit" (click)="save()">
      {{ id ? t("role.btnUpdate") : t("role.btnCreate") }}
    </button>
    <button mat-stroked-button type="button" class="margin-left-right-10" (click)="onClose()">
      {{ t("role.btnCancel") }}
    </button>
  </div>
</ng-container>